import React, { useEffect, useState } from "react";
import {
  Stack,
  TextField,
  InputAdornment,
  Typography,
  Button,
  Avatar,
  CircularProgress,
} from "@mui/material";
import DoneImage from "../../../Components/assets/Images/congratsdoneimage.svg";
import ErrorImage from "../../../Components/assets/Images/errorImage.svg";
import { useLocation, useNavigate } from "react-router-dom";

// import { digiLockerAuthenticationAPICall } from "../shared/APICalls";

import { useDispatch, useSelector } from "react-redux";
import { SaveEsignDocSegmentAPICall } from "../SegmentUpdateAPICalls";
import styles from "../../../pages/Styles/Redirect.module.scss";
import { REDIRECTURL } from "../../../shared/constants";

export default function SegmentEsignSuccessPage() {
  const [countDown, setCountDown] = useState(3);
  const [displayError, setDisplayError] = useState(false);
  const [loading, setLoading] = useState(false);

  const pathName = useLocation().search;
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const urlParams = new URLSearchParams(window.location.search);
  const params = Object.fromEntries(urlParams.entries());
  const doc_id = params.id;
  const reqId = params.request_id;
  const state = document.cookie;

  function sendDetails() {
    let obj: any = {
      request_id: reqId || "",
      // esign_id: doc_id,
    };
    setLoading(true);
    SaveEsignDocSegmentAPICall(obj)
      .then((response: any) => {
        const responseData = response.data;
        // console.log("res", responseData)
        setLoading(false);

        setTimeout(() => {
          window.location.href = `${REDIRECTURL}segmentUpdate/esign`;
        }, 3000);
      })
      .catch((error: any) => {
        setLoading(false);
        setDisplayError(true);
        setTimeout(() => {
          window.location.href = `${REDIRECTURL}segmentUpdate/esign`;
        }, 3000);
      });
  }

  //   useEffect(() => {
  //     sendDetails();
  //   }, []);

  useEffect(() => {
    if (window.location.href.includes("Cancelled")) {
      // console.log("cancel");
      setDisplayError(true);
    } else {
      setDisplayError(false);
      sendDetails();
    }
  }, []);

  useEffect(() => {
    const intervalId = setInterval(() => {
      setCountDown((prevCountDown) => prevCountDown - 1);
    }, 1000);

    return () => {
      clearInterval(intervalId);
    };
  }, []);

  useEffect(() => {
    if (countDown < 0) {
      setCountDown(3);
    }
  }, [countDown]);

  return (
    <>
      <div className={styles.mainWrapperTop}>
        <div className={styles.wrapper}>
          <div className={styles.step}>
            {loading ? (
              <CircularProgress style={{ width: "80px", height: "80px" }} />
            ) : (
              <img src={!displayError ? DoneImage : ErrorImage} />
            )}
          </div>
          <div className={styles.leftContainer}>
            <div className={styles.headerSection}>
              <p className={styles.signup}>
                {" "}
                {loading
                  ? "Inprogress..."
                  : displayError
                  ? "Error fetching your Documents"
                  : "We have obtained your documents"}{" "}
              </p>
              <div className={styles.textdiv}>
                <p className={styles.instructiontext}>
                  {loading
                    ? "Please wait..., we are fetching your Documents. Please don't Close the Window."
                    : `You will be redirected in 3 seconds.`}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
